import { render, staticRenderFns } from "./EventDiagnostic.vue?vue&type=template&id=c047cc22"
import script from "./EventDiagnostic.vue?vue&type=script&lang=js"
export * from "./EventDiagnostic.vue?vue&type=script&lang=js"
import style0 from "./EventDiagnostic.vue?vue&type=style&index=0&id=c047cc22&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports